<template>
  <b-card>
    <div>
      <div class="content-box">
        <div
          class="select-box"
          style="margin-bottom: 20px;width: 100%"
        >
          <unitSearch
            ref="haha"
            @submitUnitId="submitUnitId"
            @submitName="submitName"
          />
          <el-button
            type="primary"
            class="ml-1"
            size="medium"
            @click="queryIt"
          >查询</el-button>
        </div>
        <div class="table-box">
          <el-table
            :data="tableData"
            class="responsive"
          >
            <el-table-responsive-column
              type="index"
              label="序号"
            />
            <el-table-responsive-column
              prop="name"
              label="岗位名称"
            />
            <el-table-responsive-column
              prop="unit.name"
              label="设岗单位"
            />
            <el-table-responsive-column
              prop="money"
              label="月薪"
            />
            <el-table-responsive-column
              prop="numberOfNeed"
              label="岗位招聘人数"
            />
            <el-table-responsive-column
              prop="firstPassNum"
              label="初审通过人数"
            />
            <el-table-responsive-column
              prop="finalPassNum"
              label="终审通过人数"
            />
            <el-table-responsive-column label="审核状态">
              <template slot-scope="scope">
                <span>{{ scope.row.checkStatus | translateCheckStatus }}</span>
              </template>
            </el-table-responsive-column>
            <el-table-responsive-column label="操作">
              <template slot-scope="scope">
                <div v-if="scope.row.status === 'PASS'">
                  <el-button
                    type="text"
                    @click="checkThis(scope.row)"
                  >审核</el-button>
                  <el-button
                    v-if="scope.row.checkStatus === 2"
                    type="text"
                    @click="endCheck(scope.row)"
                  >结束招聘</el-button>
                </div>
                <div v-else>
                  <el-button
                    type="text"
                    @click="showThis(scope.row)"
                  >查看</el-button>
                  <span style="margin-left:10px">已结束</span>
                </div>
              </template>
            </el-table-responsive-column>
          </el-table>
        </div>
        <div class="pagination-box">
          <el-pagination
            v-if="totalSize!==0"
            :current-page="currentPage+1"
            :page-size="sizePage"
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next"
            :total="totalSize"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
        <div content="dialog-box">
          <comfirmDialog
            ref="comfirmDialog"
            title-word="结束招聘"
            :is-warning="false"
            :inner-info="DialogInnerInfo"
            :com-firm-btn="comFirmBtn"
          />
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { jobService, unitService } from '@/api/index'
import { translateCheckType } from '@/tool/utils'
import unitSearch from '@/components/UnitSearch.vue'
import comfirmDialog from '@/components/WarningDialog.vue'

export default {
  name: 'StuExAppro',
  components: {
    comfirmDialog,
    unitSearch,
  },
  filters: {
    translateCheckStatus: value => {
      const action = new Map([
        [1, '待审核'],
        [2, '审核完成'],
      ])
      return action.get(value)
    },
  },
  data() {
    return {
      currentPage: 0,
      sizePage: 10,
      unitList: [],
      unitVal: -1,
      tableData: [],
      totalSize: 0,
      DialogInnerInfo: '',
      chooseId: '',
      SearchParams: '',
      searchName: '',
    }
  },
  computed: {
    // getCurrentpage () {
    //   return this.currentPage + 1
    // }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    translateCheckType,
    // 参数
    getPrams() {
      const params = {
        page: this.currentPage,
        size: this.sizePage,
        type: 2, // 学工为2,
        unit: null,
      }
      if (this.unitVal !== -1) {
        params.unit = {
          unitId: this.unitVal,
        }
      }
      return params
    },
    initPage() {
      // eslint-disable-next-line no-prototype-builtins
      if (this.$route.params.hasOwnProperty('isgoback')) {
        this.getSessionParams()
        unitService()._allUnit().then(res => {
          if (res.status) {
            this.unitList = res.data
            this.unitList.unshift({ id: -1, name: '全部设岗单位' })
          }
        })
        this.qureyPage(this.SearchParams)
      } else {
        const params = this.getPrams()
        // 获取选项list
        unitService()._allUnit().then(res => {
          if (res.status) {
            this.unitList = res.data
            this.unitList.unshift({ id: -1, name: '全部设岗单位' })
          }
        })
        this.qureyPage(params)
      }
    },
    submitName(name) {
      this.searchName = name
    },
    submitUnitId(id) {
      if (id) {
        this.unitVal = id
      } else {
        this.unitVal = -1
      }
    },
    // 结束审核
    endCheck(row) {
      this.chooseId = row.id
      jobService()._finishCheck(row.id).then(res => {
        if (res.status) {
          // eslint-disable-next-line no-unused-expressions
          res.data ? this.DialogInnerInfo = '您当前还有学生未进行审核？是否确认结束招聘，结束招聘后该岗位无法再聘用学生，当前聘用的学生将变成在岗状态。' : this.DialogInnerInfo = '是否确认结束招聘，结束招聘后该岗位无法再聘用学生。'
          this.$refs.comfirmDialog.dialogVisible = true
        }
      })
    },
    qureyPage(params) {
      jobService()._schoolOrUnit(params).then(res => {
        if (res.status) {
          this.tableData = res.data.content
          this.totalSize = res.data.totalElements
        }
      })
    },
    // 查看
    showThis(row) {
      this.$router.push({
        name: 'AdminStuCheckPage', query: {
          id: row.id, jobName: row.name, passNum: row.finalPassNum, needNum: row.numberOfNeed, show: true, start: row.updateDate, end: row.deadTime,
        },
      })
    },
    // 筛选
    queryIt() {
      this.currentPage = 0
      const params = this.getPrams()
      // params.page = 0
      this.qureyPage(params)
    },
    handleCurrentChange(val) {
      this.currentPage = val - 1
      this.qureyPage(this.getPrams())
    },
    handleSizeChange(val) {
      this.sizePage = val
      this.qureyPage(this.getPrams())
    },
    checkThis(row) {
      const seachParams = this.getPrams()
      const searchNameParams = { name: this.searchName }
      window.sessionStorage.setItem('seachParams', JSON.stringify(seachParams))
      window.sessionStorage.setItem('seachNameParams', JSON.stringify(searchNameParams))
      this.$router.push({
        name: 'AdminStuCheckPage', query: {
          id: row.id, passNum: row.finalPassNum, needNum: row.numberOfNeed, jobName: row.name,
        },
      })
    },
    // 结束招聘得确认函数
    comFirmBtn() {
      jobService()._finishJob(this.chooseId).then(res => {
        if (res.status) {
          this.$message.success('操作成功')
          this.$refs.comfirmDialog.dialogVisible = false
          this.qureyPage(this.getPrams())
        }
      })
    },
    getSessionParams() {
      const sessionSearchKey = window.sessionStorage.getItem('seachParams')
      const sessionSearchNameKey = window.sessionStorage.getItem('seachNameParams')

      if (sessionSearchKey) {
        const sessionSearchKeyJson = JSON.parse(sessionSearchKey)
        const sessionSearchNameJson = JSON.parse(sessionSearchNameKey)
        this.SearchParams = sessionSearchKeyJson
        this.currentPage = this.SearchParams.page
        this.sizePage = this.SearchParams.size
        if (this.SearchParams.unit) {
          this.$refs.haha.$data.currentUnitId = this.SearchParams.unit.unitId
          this.$refs.haha.$data.unitQuery = sessionSearchNameJson.name
        }
      }
    },
  },
}
</script>

<style scoped lang="less">
</style>
